import * as React from "react";
import { MediaQuery } from "react-responsive";
import { getBackgroundColorClass } from "../../../colors/index.mjs";
import "debounce";
import "tabbable";
import { useResponsiveProps } from "../../../helpers/helper/hooks/use-responsive-props.mjs";
import { Image } from "../../../image/image.mjs";
import { useTheme } from "../../../helpers/theme-provider/use-theme.mjs";
import { Video } from "../../../video/video.mjs";
import { CarouselHeroContext } from "../carousel-hero/carousel-hero-context.mjs";
const CarouselHeroItem = (props) => {
  const { responsive, ...rest } = props;
  if (responsive) {
    return /* @__PURE__ */ React.createElement(CarouselHeroItemResponsive, { ...rest, responsive });
  }
  return /* @__PURE__ */ React.createElement(CarouselHeroItemInner, { ...rest });
};
const CarouselHeroItemResponsive = (props) => {
  const { responsive, ...rest } = props;
  const responsiveProps = useResponsiveProps({
    responsive
  });
  return /* @__PURE__ */ React.createElement(CarouselHeroItemInner, { ...rest, ...responsiveProps });
};
const CarouselHeroItemInner = (props) => {
  const { theme, isCurrent } = props;
  const { setTheme } = React.useContext(CarouselHeroContext);
  const { media } = useTheme();
  React.useEffect(() => {
    if (isCurrent) {
      setTheme(theme || null);
    }
  }, [theme, isCurrent, setTheme]);
  const BEM = () => {
    const classArray = ["carousel-hero__item"];
    if (backgroundClassName) {
      classArray.push(backgroundClassName);
    }
    if (props.isCurrent) {
      classArray.push("is-current");
    }
    if (props.isPrev) {
      classArray.push("is-prev");
    }
    if (props.isNext) {
      classArray.push("is-next");
    }
    if (props.isPrevCurrent) {
      classArray.push("is-prev-current");
    }
    if (props.className) {
      classArray.push(props.className);
    }
    return classArray.join(" ");
  };
  const isCustomBackground = (background) => {
    return typeof background === "string" && background.startsWith("#");
  };
  const backgroundColor = () => {
    const { background, theme: theme2 } = props;
    if (background && !isCustomBackground(background)) {
      return background;
    }
    switch (theme2) {
      case "dark":
        return "neutral-bg-level-2";
      case "light":
      default:
        return "neutral-bg-level-2";
    }
  };
  const backgroundClassName = getBackgroundColorClass(backgroundColor());
  const style = () => {
    const { background } = props;
    if (background && isCustomBackground(background)) {
      return {
        backgroundColor: background
      };
    }
    return void 0;
  };
  const renderImage = () => {
    return /* @__PURE__ */ React.createElement(
      Image,
      {
        ...props.image,
        className: "carousel-hero__background-image",
        pictureClassName: "carousel-hero__background",
        style: { minHeight: props.minHeight + "px" }
      }
    );
  };
  const renderVideo = (video) => {
    if (props.isCurrent) {
      return /* @__PURE__ */ React.createElement(MediaQuery, { minWidth: media.width.lg.min }, /* @__PURE__ */ React.createElement("div", { className: "carousel-hero__background carousel-hero__video-wrapper" }, /* @__PURE__ */ React.createElement(Video, { ...video, className: "carousel-hero__background-video", defaultPlaying: true, hideWithoutConsent: true })));
    }
    return null;
  };
  return /* @__PURE__ */ React.createElement("div", { className: BEM(), style: style() }, props.image && renderImage(), props.video && renderVideo(props.video), /* @__PURE__ */ React.createElement("div", { className: "carousel-hero__content" }, /* @__PURE__ */ React.createElement("div", { className: "carousel-hero__inner" }, props.children)));
};
export {
  CarouselHeroItem
};
